import env from '~/env'
import { useStore } from '~/store/store'

import { BetterStackBanner } from './BetterStackBanner/BetterStackBanner'
import { PrivacyModeBanner } from './PrivacyModeBanner'
import { StagingBanner } from './StagingBanner'

export const AppBanner = () => {
    const isPrivacyMode = useStore(state => state.app.isPrivacyMode)

    let environmentBanner = null
    if (env.VITE_SENTRY_ENVIRONMENT === 'staging') environmentBanner = <StagingBanner />
    else if (env.VITE_BETTERSTACK_STATUS_PAGE_URL) environmentBanner = <BetterStackBanner />

    if (isPrivacyMode) {
        return (
            <div className="flex flex-col gap-[1px]">
                {environmentBanner}
                <PrivacyModeBanner />
            </div>
        )
    }

    return environmentBanner
}
